module.exports = __webpack_public_path__ + "static/media/Rec-3-04-mobile.429704f3.webp";